module.exports = __webpack_public_path__ + "static/fonts/iconfont.c7fd604f.woff";